import { render, staticRenderFns } from "./StepReviewOwner.vue?vue&type=template&id=162e77cc&scoped=true&"
import script from "./StepReviewOwner.vue?vue&type=script&lang=js&"
export * from "./StepReviewOwner.vue?vue&type=script&lang=js&"
import style0 from "./StepReviewOwner.vue?vue&type=style&index=0&id=162e77cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e77cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})
